// @flow
import React, { useContext } from 'react';

import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridSelectField,
} from '../../../formik-utils/FieldArrayGrid';
import { STREAM_GOVERNANCE_CLOUD_PROVIDER_BACKEND_NAME } from '../../../constants';
import { STREAM_GOVERNANCE_CONFIG_ARRAY_CONFIG_MAP } from '../../../configuration/stream-governance';
import { getDropdownOptions } from '../utils';

export const ProviderNameContainer = ({ dataUniverse }) => {
  const { rowValues } = useContext(FieldArrayGridConfigItemContext);

  const providerNameConfig = STREAM_GOVERNANCE_CONFIG_ARRAY_CONFIG_MAP.get(
    STREAM_GOVERNANCE_CLOUD_PROVIDER_BACKEND_NAME
  );

  const providerNameOptions = getDropdownOptions(dataUniverse, rowValues, providerNameConfig);

  return (
    <FieldArrayGridSelectField columnConfig={providerNameConfig} options={providerNameOptions} />
  );
};
